// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"761":"a43582d5","2049":"4c3a3e7e","5020":"7962fe2e","6831":"a9ee82de","8376":"1e5a49d1","8838":"c527ebc0"}[chunkId] + ".chunk.js";
};